import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9d6076d8"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "call-to-action"
}, [/*#__PURE__*/_createElementVNode("a", {
  class: "ma-3 text-error exo font-weight-bold",
  target: "_blank",
  rel: "noopener",
  href: "https://geospatial.com/services-core-capabilities/"
}, " services › "), /*#__PURE__*/_createElementVNode("a", {
  class: "ma-3 text-error exo font-weight-bold",
  target: "_blank",
  rel: "noopener",
  href: "https://geospatial.com/industry-solutions/"
}, " industries › "), /*#__PURE__*/_createElementVNode("a", {
  class: "ma-3 text-error exo font-weight-bold",
  target: "_blank",
  rel: "noopener",
  href: "https://geospatial.com/resources/"
}, " resources › ")], -1));
const _hoisted_2 = {
  class: "copyright-container"
};
const _hoisted_3 = {
  class: "social-icon-group"
};
const _hoisted_4 = {
  class: "social-media-icon-link",
  target: "_blank",
  rel: "noopener",
  href: "https://www.facebook.com/EVGeospatial/"
};
const _hoisted_5 = {
  class: "social-media-icon-link",
  target: "_blank",
  rel: "noopener",
  href: "https://www.instagram.com/eastviewgeospatial/"
};
const _hoisted_6 = {
  class: "social-media-icon-link",
  target: "_blank",
  rel: "noopener",
  href: "https://twitter.com/EVGeospatial"
};
const _hoisted_7 = {
  class: "social-media-icon-link",
  target: "_blank",
  rel: "noopener",
  href: "https://www.linkedin.com/company/east-view-geospatial/"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://geospatial.com/support/terms-conditions/",
  target: "_blank",
  rel: "noopener",
  class: "copy-link"
}, " TERMS & CONDITIONS ", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://geospatial.com/support/privacy-policy/",
  target: "_blank",
  rel: "noopener",
  class: "copy-link"
}, " PRIVACY POLICY ", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://geospatial.com/evcompanies/",
  target: "_blank",
  rel: "noopener",
  class: "copy-link"
}, " EAST VIEW COMPANIES ", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "11px"
  }
}, "© EAST VIEW GEOSPATIAL, INC.", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_space = _resolveComponent("el-space");
  const _component_el_container = _resolveComponent("el-container");
  const _component_footer_banner = _resolveComponent("footer-banner");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_container, {
    direction: "vertical",
    class: "footer-container"
  }, {
    default: _withCtx(() => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("a", _hoisted_4, [_createVNode(_component_el_image, {
      src: require('@/assets/facebook.svg'),
      fit: "contain",
      alt: "facebook logo"
    }, null, 8, ["src"])]), _createElementVNode("a", _hoisted_5, [_createVNode(_component_el_image, {
      src: require('@/assets/instagram.svg'),
      fit: "contain",
      alt: "instagram logo"
    }, null, 8, ["src"])]), _createElementVNode("a", _hoisted_6, [_createVNode(_component_el_image, {
      src: require('@/assets/twitter.svg'),
      fit: "contain",
      alt: "twitter logo"
    }, null, 8, ["src"])]), _createElementVNode("a", _hoisted_7, [_createVNode(_component_el_image, {
      src: require('@/assets/linkedin.svg'),
      fit: "contain",
      alt: "LinkedIn logo"
    }, null, 8, ["src"])])]), _createVNode(_component_el_space, {
      class: "footer-links",
      wrap: "",
      spacer: "|"
    }, {
      default: _withCtx(() => [_hoisted_8, _hoisted_9, _hoisted_10]),
      _: 1
    }), _hoisted_11])]),
    _: 1
  }), _createVNode(_component_footer_banner)], 64);
}